import { Emotion } from '../types/index';
import { Gender } from '../hooks/useGender';

export const EMOTIONS_MASCULINE: Emotion[] = [
  { id: 'happy', label: 'Feliz', emoji: '😊' },
  { id: 'sad', label: 'Triste', emoji: '😢' },
  { id: 'anxious', label: 'Ansioso', emoji: '😰' },
  { id: 'angry', label: 'Enojado', emoji: '😠' },
  { id: 'tired', label: 'Cansado', emoji: '😴' },
  { id: 'calm', label: 'Tranquilo', emoji: '😌' },
];

export const EMOTIONS_FEMININE: Emotion[] = [
  { id: 'happy', label: 'Feliz', emoji: '😊' },
  { id: 'sad', label: 'Triste', emoji: '😢' },
  { id: 'anxious', label: 'Ansiosa', emoji: '😰' },
  { id: 'angry', label: 'Enojada', emoji: '😠' },
  { id: 'tired', label: 'Cansada', emoji: '😴' },
  { id: 'calm', label: 'Tranquila', emoji: '😌' },
];

export const getEmotions = (gender: Gender | null): Emotion[] => {
  if (gender === 'female') return EMOTIONS_FEMININE;
  return EMOTIONS_MASCULINE;
};

// Mantenemos compatibilidad con imports anteriores
export const EMOTIONS = EMOTIONS_MASCULINE;

export const ONBOARDING_TAGS = ['Tierno', 'Amigable', 'Comprensivo', 'Siempre contigo'];
